module.exports = __webpack_public_path__ + "img/marvin-mockup.379757e4.jpg";